import { apiService } from '@/services/apiService';

export const generateSitemapXML = async (): Promise<string> => {
  try {
    // Fetch all posts - increase limit to get all posts
    const { posts } = await apiService.fetchPosts(1, 100);
    
    const baseUrl = 'https://ai4hack.com';
    
    // Static routes with their properties
    const staticRoutes = [
      { url: '/', changefreq: 'daily', priority: '1.0' },
      { url: '/media', changefreq: 'daily', priority: '0.9' },
      { url: '/privacy-policy', changefreq: 'monthly', priority: '0.5' },
      { url: '/terms', changefreq: 'monthly', priority: '0.5' }
    ];
    
    // Start XML
    let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`;

    // Add static routes
    staticRoutes.forEach(({ url, changefreq, priority }) => {
      sitemap += `
  <url>
    <loc>${baseUrl}${url}</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;
    });

    // Add blog post routes
    posts.forEach(post => {
      sitemap += `
  <url>
    <loc>${baseUrl}/media/${post.slug}</loc>
    <lastmod>${new Date(post.date).toISOString().split('T')[0]}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.8</priority>
  </url>`;
    });

    sitemap += `
</urlset>`;

    return sitemap;
  } catch (error) {
    console.error('Error generating sitemap:', error);
    
    // Return fallback sitemap with static routes only
    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://ai4hack.com/</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>daily</changefreq>
    <priority>1.0</priority>
  </url>
  <url>
    <loc>https://ai4hack.com/media</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>daily</changefreq>
    <priority>0.9</priority>
  </url>
  <url>
    <loc>https://ai4hack.com/privacy-policy</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
  <url>
    <loc>https://ai4hack.com/terms</loc>
    <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
    <changefreq>monthly</changefreq>
    <priority>0.5</priority>
  </url>
</urlset>`;
  }
};

export const generateRobotsText = (): string => {
  return `User-agent: *
Allow: /

# Sitemap
Sitemap: https://ai4hack.com/sitemap.xml

# Crawl-delay
Crawl-delay: 1

# Allow all major search engine bots
User-agent: Googlebot
Allow: /

User-agent: Bingbot
Allow: /

User-agent: Slurp
Allow: /

User-agent: DuckDuckBot
Allow: /

User-agent: Baiduspider
Allow: /

User-agent: YandexBot
Allow: /

# Social media bots
User-agent: facebookexternalhit
Allow: /

User-agent: Twitterbot
Allow: /

User-agent: LinkedInBot
Allow: /

# Allow common file types
Allow: *.css
Allow: *.js
Allow: *.jpg
Allow: *.jpeg
Allow: *.png
Allow: *.gif
Allow: *.webp
Allow: *.svg
Allow: *.pdf
Allow: *.woff
Allow: *.woff2
Allow: *.ttf
Allow: *.eot`;
};